<template>
  <div>
    <draggable
      class="l-drag-from"
      :list="_columns"
      group="form"
      :options="{ animation: 300, chosenClass: 'choose', sort: true }"
      @start="
        drag = true;
        selectFormItem = null;
      "
      @end="drag = false"
    >
      <div
        v-for="(cp, id) in _columns"
        :key="id"
        class="l-form-item"
        @click.stop="selectItem(cp)"
        :style="getSelectedClass(cp)"
      >
        <div class="l-form-header">
          <p> {{ cp.title }}</p>
          <div class="l-option">
            <i class="el-icon-close" @click="delItem(id)"></i>
          </div>
          <form-design-render :config="cp" />
        </div>
      </div>
    </draggable>
    <div style="color: #c0bebe; text-align: center; width: 90%; padding: 5px">
      ☝ 拖拽控件到表格内部
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import FormDesignRender from "@/views/admin/layout/form/FormDesignRender";

export default {
  name: "TableList",
  components: { draggable, FormDesignRender },
  props: {
    columns: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  computed: {
    _columns: {
      get() {
        return this.columns;
      },
      set(val) {
        this.columns = val;
      },
    },
    selectFormItem: {
      get() {
        return this.$store.state.selectFormItem;
      },
      set(val) {
        this.$store.state.selectFormItem = val;
      },
    },
  },
  data() {
    return {
      select: null,
      drag: false,
    };
  },
  methods: {
    delItem(id) {
      this._columns.splice(id, 1);
    },
    selectItem(cp) {
      this.selectFormItem = cp;
    },
    getSelectedClass(cp) {
      return this.selectFormItem && this.selectFormItem.id === cp.id
        ? "border-left: 4px solid #f56c6c"
        : "";
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .valid-error {
  .el-input__inner {
    border-color: #f56c6c;
  }
}

.choose {
  border: 1px dashed @theme-primary !important;
}

.table-column {
  padding: 5px;
  margin-bottom: 10px;
  border-left: 3px solid #107FFF;
  border-radius: 5px;
  background: #fafafa;
  /deep/ .el-form-item {
    margin-bottom: 0;
    .el-form-item__label {
      height: 25px;
    }
  }
  .table-column-action {
    float: right;
    span {
      color: #afafaf;
      margin-right: 10px;
      font-size: 13px;
    }
    i {
      color: #afafaf;
      padding: 5px;
      font-size: large;
      cursor: pointer;
      &:hover {
        color: #666666;
      }
    }
  }
}

.l-drag-from {
  min-height: 50px;
  background-color: rgb(245, 246, 246);
  display: flex;
  overflow-x: auto;

  .l-form-item {
    cursor: grab;
    min-width: 140px;
    background: #ffffff;
    padding: 10px;
    border: 1px solid #ebecee;
    margin: 5px 0;
  }
}

.l-form-header {
  font-size: small;
  color: #818181;
  text-align: left;
  position: relative;
  background-color: #fff;

  p {
    position: relative;
    margin: 0 0 10px 0;

    span {
      position: absolute;
      left: -8px;
      top: 3px;
      color: rgb(217, 0, 19);
    }
  }

  .l-option {
    position: absolute;
    top: -10px;
    right: -10px;

    i {
      font-size: large;
      cursor: pointer;
      color: #8c8c8c;
      padding: 5px;

      &:hover {
        color: @theme-primary;
      }
    }
  }
}
</style>
